import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const NavigationShortcuts = () => {
  const shortcuts = [
    {
      id: 'products',
      title: 'Product Management',
      description: 'Add, edit, and organize products',
      icon: 'Package',
      path: '/product-catalog',
      color: 'bg-primary/10 text-primary',
      stats: '1,247 products'
    },
    {
      id: 'inventory',
      title: 'Inventory Control',
      description: 'Monitor stock levels and alerts',
      icon: 'Warehouse',
      path: '/admin/inventory',
      color: 'bg-warning/10 text-warning',
      stats: '8 low stock'
    },
    {
      id: 'vendors',
      title: 'Vendor Dashboard',
      description: 'Manage vendor relationships',
      icon: 'Building2',
      path: '/admin/vendors',
      color: 'bg-accent/10 text-accent-foreground',
      stats: '45 active vendors'
    },
    {
      id: 'customers',
      title: 'Customer Service',
      description: 'Support and user management',
      icon: 'Users',
      path: '/admin/customers',
      color: 'bg-success/10 text-success',
      stats: '12 open tickets'
    },
    {
      id: 'orders',
      title: 'Order Management',
      description: 'Process and track orders',
      icon: 'ShoppingCart',
      path: '/shopping-cart',
      color: 'bg-secondary/10 text-secondary',
      stats: '23 pending'
    },
    {
      id: 'analytics',
      title: 'Analytics & Reports',
      description: 'Business intelligence dashboard',
      icon: 'BarChart3',
      path: '/admin/analytics',
      color: 'bg-error/10 text-error',
      stats: 'View insights'
    }
  ];

  return (
    <div className="bg-card rounded-xl border border-border p-6 shadow-elevation-1">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-heading font-semibold text-foreground">Quick Navigation</h3>
          <p className="text-sm text-muted-foreground">Access key management areas</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-4">
        {shortcuts?.map((shortcut) => (
          <Link
            key={shortcut?.id}
            to={shortcut?.path}
            className="group p-3.5 bg-muted/50 rounded-lg border border-border hover:bg-muted hover:shadow-elevation-1 transition-all duration-200"
          >
            <div className="flex items-start space-x-3">
              <div className={`w-9 h-9 flex-shrink-0 rounded-lg flex items-center justify-center ${shortcut?.color} group-hover:scale-110 transition-transform`}>
                <Icon name={shortcut?.icon} size={18} />
              </div>
              
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-foreground group-hover:text-primary transition-colors break-words">
                  {shortcut?.title}
                </h4>
                <p className="text-xs text-muted-foreground mt-0.5 line-clamp-1 break-words">
                  {shortcut?.description}
                </p>
                <div className="flex items-center justify-between mt-1.5 gap-2">
                  <span className="text-xs font-medium text-muted-foreground truncate">
                    {shortcut?.stats}
                  </span>
                  <Icon 
                    name="ArrowRight" 
                    size={13} 
                    className="text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all flex-shrink-0" 
                  />
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <div className="grid grid-cols-2 gap-4">
          <Link
            to="/admin/settings"
            className="flex items-center justify-center space-x-2 p-3 bg-muted/50 rounded-lg border border-border hover:bg-muted transition-smooth"
          >
            <Icon name="Settings" size={16} className="text-muted-foreground" />
            <span className="text-sm font-medium text-muted-foreground">Settings</span>
          </Link>
          <Link
            to="/admin/help"
            className="flex items-center justify-center space-x-2 p-3 bg-muted/50 rounded-lg border border-border hover:bg-muted transition-smooth"
          >
            <Icon name="HelpCircle" size={16} className="text-muted-foreground" />
            <span className="text-sm font-medium text-muted-foreground">Help Center</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NavigationShortcuts;